import { Snackbar } from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import Alert from "@material-ui/lab/Alert"
import React, { useState } from "react"

import AccountProfile from "../Account/AccountProfile"
import AccountSecurity from "../Account/AccountSecurity"
import TabContentContainer from "../Common/ContentContainers/TabContentContainer"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"

const styles = (theme) => ({
  toolbar: theme.mixins.toolbar,
})

const AccountRedo = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarSeverity, setSnackbarSeverity] = useState("success")

  const openSnackbar = (message, severity) => {
    setSnackbarOpen(true)
    setSnackbarMessage(message)
    setSnackbarSeverity(severity)
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false)
  }

  const tabs = [
    {
      label: "Profile",
      content: <AccountProfile openSnackbar={openSnackbar} />,
    },
    {
      label: "Security",
      content: <AccountSecurity openSnackbar={openSnackbar} />,
    },
  ]

  return (
    <HomePageWrapper>
      <TabContentContainer tabs={tabs} />
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <br />
    </HomePageWrapper>
  )
}

export default withStyles(styles)(AccountRedo)
